import { render, staticRenderFns } from "./SafetyObservationView.vue?vue&type=template&id=f82df016&"
import script from "./SafetyObservationView.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports